// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ProductContext, ProductContextModel } from "@insite/client-framework/Components/ProductContext";
import * as React from "react";

export type HasCarouselProduct = ProductContextModel;

export interface HasCarouselProductContext {
    productContext: ProductContextModel;
}

export function withCarouselProductContext<P extends HasCarouselProductContext>(Component: React.ComponentType<P>) {
    return function ProductComponent(props: Omit<P, keyof HasCarouselProductContext>) {
        return (
            <ProductContext.Consumer>
                {value => <Component {...(props as P)} productContext={value} />}
            </ProductContext.Consumer>
        );
    };
}

export function withCarouselProduct<P extends HasCarouselProduct>(Component: React.ComponentType<P>) {
    return function ProductComponent(props: Omit<P, keyof HasCarouselProduct>) {
        return (
            <ProductContext.Consumer>
                {value => (
                    <Component
                        {...(props as P)}
                        product={value.product}
                        productInfo={value.productInfo}
                        onQtyOrderedChanged={value.onQtyOrderedChanged}
                        onUnitOfMeasureChanged={value.onUnitOfMeasureChanged}
                    />
                )}
            </ProductContext.Consumer>
        );
    };
}
